import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { TRUST_URL } from "../lib/constants";

export const StickyMobileCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.85);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-50 md:hidden px-4 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] bg-gradient-to-t from-ink via-ink/95 to-transparent"
          data-testid="sticky-mobile-cta"
        >
          <a
            href={TRUST_URL}
            data-testid="sticky-mobile-cta-btn"
            className="flex items-center justify-center gap-2.5 w-full bg-gold text-ink font-bold tracking-[0.1em] uppercase text-sm py-4 rounded-full shadow-[0_0_35px_rgba(201,162,60,0.45)] active:scale-[0.98] transition-transform duration-200"
          >
            Get Started
            <ArrowRight size={17} />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
